{
	"main": {
		"title": "Nastavitve računa"
	},
	"geslo": {
		"title": "Spremeni uporabniško geslo",
		"description": "Posodobite svoje geslo za večjo varnost",
		"labels": {
			"staroGeslo": "Staro geslo",
			"novoGeslo": "Novo geslo",
			"potrditevGesla": "Potrditev novega gesla"
		},
		"buttons": {
			"ponastaviGeslo": "Ponastavi geslo"
		}
	},
	"podatki": {
		"title": "Podatki pilota",
		"description": "Urejanje podatkov (Naslov, telefon, email)"
	},
	"podpis": {
		"title": "Digitalni podpis",
		"description": "Dodajte svoj podpis za račune"
	},
	"auth": {
		"title": "2FA avtentikacija",
		"description": "Nastavitve 2FA avtentikacije"
	},
	"language": {
		"title": "Jezik",
		"description": "Nastavitve jezika uporabniškega vmesnika"
	},
	"buttons": {
		"zakljuci": "Zaključi urejanje"
	},
	"bracun": {
		"title": "Izbris računa",
		"description": "Brisanje/deaktivacija računa"
	},
	"obvestila": {
		"podpisDodan": "Podpis dodan v račun. Podpis bo viden po ponovni prijavi",
		"gesloSpremenjeno": "Geslo uspešno spremenjeno. Samodejno boste odjavljeni čez nekaj sekund...",
		"gesloNiUjema": "Gesli se ne ujemata",
		"napacnoGeslo": "Vneseno staro geslo je napačno!",
		"napakaPosodabljanja": "Napaka pri posodabljanju podatkov",
		"napakaBranja": "Napaka pri branju podatkov"
	}
}